import { render, staticRenderFns } from "./WebsiteVideoCard.vue?vue&type=template&id=f28e28d4&scoped=true&"
import script from "./WebsiteVideoCard.vue?vue&type=script&lang=js&"
export * from "./WebsiteVideoCard.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteVideoCard.vue?vue&type=style&index=0&id=f28e28d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28e28d4",
  null
  
)

export default component.exports